<template>
  <section class="sf-image-text px-4 sm:px-0 pb-10">
    <!-- Imagem de fundo com texto sobreposto -->
    <div
      v-if="position === 'background'"
      class="sf-image-text__bg flex items-center justify-center text-center"
      :style="imageUrl ? { backgroundImage: `url('${imageUrl}')` } : {}"
    >
      <div class="sf-image-text__overlay"></div>
      <div class="relative px-6 py-12 max-w-2xl">
        <h3 class="sf-image-text__title text-2xl md:text-4xl font-bold text-white">{{ section.settings.title }}</h3>
        <p v-if="section.settings.text" class="sf-image-text__text mt-3 text-white/90 text-sm md:text-base">{{ section.settings.text }}</p>
        <button v-if="hasButton" type="button" class="sf-image-text__button mt-6" @click="onButtonClick">{{ section.settings.buttonText }}</button>
      </div>
    </div>

    <!-- Imagem ao lado do texto -->
    <div v-else class="sf-image-text__split grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
      <div v-if="imageUrl" class="sf-image-text__media" :class="position === 'right' ? 'md:order-2' : ''">
        <img :src="imageUrl" :alt="section.settings.title" loading="lazy">
      </div>
      <div :class="[position === 'right' ? 'md:order-1' : '', !imageUrl ? 'md:col-span-2 text-center' : '']">
        <h3 class="sf-heading text-2xl md:text-3xl font-bold">{{ section.settings.title }}</h3>
        <p v-if="section.settings.text" class="sf-image-text__text mt-3 text-sm md:text-base whitespace-pre-line">{{ section.settings.text }}</p>
        <button v-if="hasButton" type="button" class="sf-image-text__button mt-6" @click="onButtonClick">{{ section.settings.buttonText }}</button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { ImageTextSection } from '@/global/state/StorefrontState'
import { openStorefrontLink, resolveMediaUrl } from '../storefrontUtils'

/* global defineProps */
const props = defineProps<{ section: ImageTextSection }>()
const router = useRouter()

const position = computed(() => props.section.settings?.imagePosition ?? 'left')
const imageUrl = computed(() => resolveMediaUrl(props.section.settings?.imageUrl))
const hasButton = computed(() => !!props.section.settings?.buttonText && !!props.section.settings?.buttonLink)

function onButtonClick() {
  openStorefrontLink(router, props.section.settings.buttonLink)
}
</script>

<style>
.sf-image-text__bg {
  position: relative;
  min-height: 18rem;
  overflow: hidden;
  border-radius: var(--sf-radius);
  background-color: #292f31;
  background-size: cover;
  background-position: center;
}
@media (min-width: 768px) {
  .sf-image-text__bg {
    min-height: 24rem;
  }
}
.sf-image-text__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, .35), rgba(0, 0, 0, .6));
}
.sf-image-text__title {
  font-family: var(--sf-heading-font);
}
.sf-image-text__media {
  overflow: hidden;
  border-radius: var(--sf-radius);
}
.sf-image-text__media img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  display: block;
}
.sf-image-text__split .sf-image-text__text {
  color: var(--sf-muted);
}
.sf-image-text__button {
  display: inline-flex;
  align-items: center;
  padding: .75rem 1.75rem;
  font-weight: 600;
  font-size: .9rem;
  color: #fff;
  background: var(--sf-primary);
  border-radius: var(--sf-radius);
  transition: opacity .2s, transform .2s;
}
.sf-image-text__button:hover {
  opacity: .9;
  transform: translateY(-1px);
}
</style>
